import {autoserializeAs, inheritSerialization} from 'cerialize';
import {RsvpAnswerTransformer} from '../helpers/subtypes/rsvp-answer-transformer';
import {ModelBase} from './model-base';
import {RsvpAnswer} from './rsvp-answer';
import { RsvpMultipleChoiceAnswer } from './rsvp-multiple-choice-answer';
import { RsvpMultipleChoiceQuestion } from './rsvp-multiple-choice-question';
import { RsvpOpenAnswer } from './rsvp-open-answer';
import { RsvpOpenQuestion } from './rsvp-open-question';
import { RsvpQuestion } from './rsvp-question';
import { RsvpQuestionOption } from './rsvp-question-option';

@inheritSerialization(ModelBase)
export class RsvpPerson extends ModelBase {
  public static readonly type = 'RsvpPerson';
  public readonly type = RsvpPerson.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('rsvp_id')
  public rsvpId: number;

  @autoserializeAs('name')
  public name: string;

  @autoserializeAs('is_user')
  public isUser: boolean;

  @autoserializeAs(RsvpAnswerTransformer, 'answers')
  public answers: RsvpAnswer[] = [];

  public getAnswerForQuestion(rsvpQuestion: RsvpQuestion): RsvpOpenAnswer | RsvpQuestionOption {
    if (rsvpQuestion.type == RsvpMultipleChoiceQuestion.type) {
      if (this.answers == null) {
        return null;
      }
  
      const answer = this.answers.find(answer => answer.rsvpQuestionId === rsvpQuestion.id) as RsvpMultipleChoiceAnswer;
      if (answer == null) {
        return null;
      }
  
      return (rsvpQuestion as RsvpMultipleChoiceQuestion).rsvpQuestionOptions.find(option => option.id === answer.rsvpQuestionOptionId);
    } else if (rsvpQuestion.type == RsvpOpenQuestion.type) {
      return this.answers.find(answer => answer.rsvpQuestionId === rsvpQuestion.id) as RsvpOpenAnswer;
    }
  }
}
